import { useState } from "react";
import {
  ArrowRight,
  Check,
  LockKeyhole,
  Mail,
  ShieldCheck,
  Sparkles,
  Zap,
} from "lucide-react";
import { cadastrarUsuario, entrarUsuario } from "../services/authService";

export default function LoginPage() {
  const [modo, setModo] = useState("entrar");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [aceitouPolitica, setAceitouPolitica] = useState(false);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  async function enviar(e) {
    e.preventDefault();
    setErro("");

    if (!aceitouPolitica) {
      setErro("Você precisa aceitar a Política de Privacidade para continuar.");
      return;
    }

    setCarregando(true);

    try {
      if (modo === "cadastro") {
        await cadastrarUsuario({ nome, email, senha });
      } else {
        await entrarUsuario({ email, senha });
      }
    } catch (error) {
      console.error("ERRO FIREBASE:", error.code, error.message);
      setErro(`${error.code} - ${error.message}`);
    } finally {
      setCarregando(false);
    }
  }

  return (
    <main className="login-page invexa-login-v3">
      <div className="login-glow login-glow-one" />
      <div className="login-glow login-glow-two" />
      <div className="login-orbit" />

      <section className="login-hero">
     <div className="login-logo-block" aria-label="Invexa Finance">
  <img
    src="/logo-invexa.png"
    alt="Invexa Finance"
    className="login-real-logo"
  />
</div>
        <div className="brand-pill login-status-pill">
          <span /> Seu financeiro, do seu jeito.
        </div>

        <h1>
         A maneira mais moderna de cuidar do seu dinheiro, metas e crescimento financeiro.
        </h1>

        <p>
          Organize entradas, saídas, dívidas e metas em uma plataforma moderna,
          limpa e pensada para facilitar sua vida financeira.
        </p>

        <div className="hero-grid login-feature-grid">
          <div className="hero-card login-feature-card">
            <div className="login-feature-icon"><Zap size={24} /></div>
            <strong>Entrada rápida</strong>
            <span>Registre receita ou despesa em poucos segundos.</span>
          </div>

          <div className="hero-card login-feature-card">
            <div className="login-feature-icon purple"><ShieldCheck size={24} /></div>
            <strong>Seus dados seguros</strong>
            <span>Cada usuário acessa apenas seus próprios dados.</span>
          </div>
        </div>
      </section>

      <section className="login-card glass-card login-panel">
        <div className="login-tabs" role="tablist">
          <button
            type="button"
            className={modo === "entrar" ? "active" : ""}
            onClick={() => {
              setErro("");
              setModo("entrar");
            }}
          >
            Entrar
          </button>
          <button
            type="button"
            className={modo === "cadastro" ? "active" : ""}
            onClick={() => {
              setErro("");
              setModo("cadastro");
            }}
          >
            Criar conta
          </button>
        </div>

        <div className="login-panel-heading">
          <h2>{modo === "cadastro" ? "Crie sua conta" : "Bem-vindo de volta!"}</h2>
          <p>
            {modo === "cadastro"
              ? "Comece com 15 dias grátis para testar."
              : "Acesse sua área financeira da Invexa."}
          </p>
        </div>

        <form onSubmit={enviar} className="login-form-premium">
          {modo === "cadastro" && (
            <label className="login-field">
              Nome / Negócio
              <div className="login-input-wrap">
                <Sparkles size={20} />
                <input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Ex: João Silva ou Invexa Soluções"
                />
              </div>
            </label>
          )}

          <label className="login-field">
            E-mail
            <div className="login-input-wrap">
              <Mail size={20} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@email.com"
                required
              />
            </div>
          </label>

          <label className="login-field">
            Senha
            <div className="login-input-wrap">
              <LockKeyhole size={20} />
              <input
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="mínimo 6 caracteres"
                required
              />
            </div>
          </label>

          <label className="privacy-check premium-check">
            <input
              type="checkbox"
              checked={aceitouPolitica}
              onChange={(e) => setAceitouPolitica(e.target.checked)}
            />
            <span className="premium-check-box"><Check size={16} /></span>
            <span>
              Li e aceito a{" "}
              <a href="/privacy" target="_blank" rel="noreferrer">
                Política de Privacidade
              </a>
              .
            </span>
          </label>

          {erro && <div className="error-box">{erro}</div>}

          <button className="primary-btn login-submit" type="submit" disabled={carregando}>
            {carregando
              ? "Carregando..."
              : modo === "cadastro"
              ? "Começar teste grátis"
              : "Entrar"}
            <ArrowRight size={20} />
          </button>
        </form>

        <p className="login-switch-text">
          {modo === "cadastro" ? "Já tem uma conta?" : "Não tem uma conta?"}{" "}
          <button
            type="button"
            onClick={() => {
              setErro("");
              setModo(modo === "cadastro" ? "entrar" : "cadastro");
            }}
          >
            {modo === "cadastro" ? "Entrar" : "Criar nova conta"}
          </button>
        </p>
      </section>
    </main>
  );
}
